import styled from "styled-components";

import {
	DESKTOP_SM_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	TABLET_BP,
	MOBILE_L_BP,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_LIGHT_GREY,
	COLOR_LIGHT_GREEN,
	COLOR_GREY_BORDER,
} from "@website-builder/utilities-index";

export const HeroWrapper = styled.div`
	padding-top: 90px;
	display: flex;
	align-items: center;
	background-image: linear-gradient(
		to top,
		${COLOR_LIGHT_GREY} 5%,
		${COLOR_LIGHT_GREEN} 96%
	);
	color: ${(props) => props.fontColor};
	.mobileContainer {
		display: none;
	}
	.joinusWrapper {
		max-width: 570px;
		margin-left: 70px;
		h2.header {
			font-weight: ${FONT_WT_MEDIUM};
			font-size: 36px;
			line-height: 1.4;
			margin: 0 0 30px 0;
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
		div.description {
			margin: 0 0 40px 0;
		}
		div.description {
			font-weight: ${FONT_WT_LIGHT};
			font-size: 18px;
			line-height: 1.44;
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
	}
	.imageWrapper {
		.videoDesc {
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			font-style: italic;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			margin-top: 14px;
		}
		.videoContainer {
			margin-top: 85px;
			margin-right: 105px;
			height: 364px !important;
			width: 550px !important;
			div {
				iframe {
					border-radius: 3px;
				}
			}
		}
		margin-bottom: 60px;
		.imageWrapper:first-child {
			width: 200px !important;
		}
		.thumbNailContainer {
			display: flex;
			.thumbNail {
				cursor: pointer;
				picture {
					img {
						height: 76px;
						width: 106px;
						margin-right: 5px;
						margin-top: 20px;
						border-radius: 3px;
					}
				}
			}
		}
		margin-left: 160px;
		margin-right: auto;
		width: 65%;
		h3.header {
			margin: 0 0 25px 0;
			font-weight: ${FONT_WT_MEDIUM};
			font-size: 20px;
			line-height: 20px;
		}
		.heroImage {
			float: right;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		display: block;
		padding: 35px 30px;
		padding-top: 90px;
		.mobileContainer {
			display: flex;
			justify-content: center;
			flex-flow: wrap;
		}
		.mobileContainer {
			.mobileThumbnail {
				cursor: pointer;
				picture {
					img {
						height: 94px;
						width: 140px;
						margin-right: 5px;
						border: solid 1px ${COLOR_GREY_BORDER};
						border-radius: 3px;
					}
				}
			}
		}
		.modalBody {
			.videoContainer {
				height: 364px !important;
				width: 515px !important;
			}
		}
		.imageWrapper {
			display: none;
		}
		a {
			text-decoration: none;
		}
		.joinusWrapper {
			margin: 0 auto;
			margin-bottom: 35px;
			h2.header {
				text-align: center;
				font-size: 26px;
				line-height: 36px;
				margin: 35px 20px 15px 20px;
			}
			div.description {
				font-size: 16px;
				line-height: 27px;
				text-align: center;
			}
			.join-button {
				display: flex;
				margin: auto;
				align-items: center;
			}
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: block;
		padding: 35px 20px;
		padding-top: 90px;
		.joinusWrapper {
			h2.header {
				margin: 0px 0px 30px 0px;
				font-size: 28px;
				line-height: 1.21;
			}
			div.description {
				font-size: 18px;
				line-height: 1.44;
				text-align: center;
				margin-left: 25px;
				margin-right: 25px;
			}
		}
		.join-button {
			display: flex;
			margin: auto;
			align-items: center;
			padding: 0px 25px;
		}
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		${(props) => (props.showInTabletAndMobile ? "" : "display: none")}
		.join-button {
			display: flex;
			margin: auto;
			align-items: center;
		}
	}
`;
